"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Facebook icon
var Facebook = function Facebook(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M3.49995 1.69995C2.50714 1.69995 1.69995 2.50714 1.69995 3.49995V12.5C1.69995 13.4928 2.50714 14.3 3.49995 14.3H6.26183V10.1993H4.77683V7.99995H6.26183V7.05214C6.26183 4.60245 7.36995 3.4662 9.77745 3.4662C10.2331 3.4662 11.0206 3.5562 11.344 3.6462V5.63745C11.1753 5.62058 10.88 5.60933 10.5115 5.60933C9.33026 5.60933 8.87464 6.05651 8.87464 7.21808V7.99995H11.2259L10.8209 10.1993H8.87183V14.3H12.5C13.4928 14.3 14.3 13.4928 14.3 12.5V3.49995C14.3 2.50714 13.4928 1.69995 12.5 1.69995H3.49995Z",
    fill: "#1877F2"
  }));
};

var _default = Facebook;
exports.default = _default;